import axios from "axios";
import React, { useContext, useState } from "react";
import { MyContext } from "../../../context/MyContext";

const UpiId = ({ onClose }) => {
  const { getUpiDetail } = useContext(MyContext);
  const [upiId, setUpiId] = useState("");
  const [upiName, setUpiName] = useState("");
  const [errors, setErrors] = useState({});
  const userId = localStorage.getItem("userId");
  const validate = () => {
    const newErrors = {};
    if (!upiName.trim()) {
      newErrors.upiName = "Upi Name is required";
    }
    if (!upiId.trim()) {
      newErrors.upiId = "UPI id is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(upiId, upiName);

    if (!validate()) return;

    const body = {
      upiId: upiId,
      upiName: upiName,
    };
    await axios
      .post(`${process.env.REACT_APP_NODE}user/upi/${userId}`, body)
      .then((response) => {
        console.log(response.data);
        onClose();
        getUpiDetail();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-gray-600  text-xl"
        >
          ✖
        </button>

        <h2 className="text-xl font-semibold text-center mb-4"> UPI Details</h2>

        <form className="flex flex-col gap-4">
          <div>
            <label className="block font-medium">UPI ID</label>
            <input
              type="text"
              value={upiId}
              placeholder="123@upi"
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
              onChange={(e) => {
                setUpiId(e.target.value);
              }}
            />
            {errors.upiId && (
              <p className="text-red-500 text-sm">{errors.upiId}</p>
            )}
          </div>
          <div>
            <label className="block font-medium">UPI Name</label>
            <input
              type="text"
              value={upiName}
              placeholder="Enter UPI Name"
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
              onChange={(e) => {
                setUpiName(e.target.value);
              }}
            />
            {errors.upiName && (
              <p className="text-red-500 text-sm">{errors.upiName}</p>
            )}
          </div>
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 transition w-full text-white font-semibold rounded-lg py-2"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpiId;
